import * as React from 'react';

import { PageTitleBar } from 'components';

const ProductCommentHeader = ({
  children,
}: React.PropsWithChildren<unknown>) => <PageTitleBar headerTitle={children} />;

export { ProductCommentHeader };
